import { ContractsService } from "@/core/libs/api";

export const downloadContract = async (
  contractId: string,
  setIsDownloadingContract: (isDownloading: boolean) => void
) => {
  setIsDownloadingContract(true);

  const abortController = new AbortController();
  const { signal } = abortController;
  const params = {
    id: contractId
  };

  const service = ContractsService();
  const response = await service.downloadContract({ params, signal });
  response.data && window.open(response.data, "_blank");

  setIsDownloadingContract(false);
};
